export default __webpack_public_path__ + "static/on-track-d28ee5d2e4c04b29db68fe08802e711a.svg";